import { Typography } from "@suraasa/placebo-ui"
import SuraasaPlusOverlay from "assets/masterclass/suraasa-plus-overlay.webp"
import UnlockIcon from "assets/masterclass/suraasa-plus-unlock.webp"
import DEFAULT_MASTERCLASS_IMAGE from "assets/Placeholder/default-masterclass-thumbnail.svg"
import { differenceInCalendarDays } from "date-fns"
import SuraasaPlusLogo from "features/SuraasaPlus/components/SuraasaPlusLogo"
import { PlaySolid } from "iconoir-react"
import { pluralize } from "utils/helpers"

const getValidityLabel = (creditValidity?: string | null): string | null => {
  if (!creditValidity) {
    return null
  }

  const expiry = new Date(creditValidity)

  if (Number.isNaN(expiry.getTime())) {
    return null
  }

  const today = new Date()
  const daysLeft = Math.max(0, differenceInCalendarDays(expiry, today))

  if (daysLeft === 0) {
    return "Today"
  }

  return pluralize("day", daysLeft)
}

const PauseScreen = ({
  thumbnail,
  creditValidity,
}: {
  thumbnail: string
  creditValidity?: string | null
}) => {
  const validityLabel = getValidityLabel(creditValidity)

  return (
    <>
      <div
        className="absolute inset-0 z-10 bg-[rgba(0,0,0,0.80)] bg-cover bg-center p-2 sm:p-4"
        style={{
          backgroundImage: `url(${SuraasaPlusOverlay})`,
        }}
      >
        <div className="flex flex-wrap items-center justify-between">
          <div>
            {validityLabel && (
              <Typography className="mt-1 text-smallBody text-surface-50 sm:text-body">
                This masterclass is available for{" "}
                <span className="text-strongSmallBody text-surface sm:text-strong">
                  {validityLabel}
                </span>
              </Typography>
            )}

            <div className="flex items-center gap-0.5">
              <Typography
                className="mt-0.75 text-onSurface-300"
                variant="smallBody"
              >
                Get unlimited access with
              </Typography>
              <SuraasaPlusLogo color="light" height={15} width={82} />
            </div>
          </div>

          <img
            src={UnlockIcon}
            alt=""
            className="h-3 w-2 text-surface-100 sm:h-5 sm:w-4"
          />
        </div>

        <div className="absolute inset-0 flex items-center justify-center">
          <PlaySolid className="size-8 text-surface sm:size-[150px]" />
        </div>
      </div>

      <img
        alt="thumbnail"
        className="w-full rounded-lg"
        src={thumbnail}
        onError={e => (e.currentTarget.src = DEFAULT_MASTERCLASS_IMAGE)}
      />
    </>
  )
}

export default PauseScreen
